// Static data for the entire platform

export const CATEGORIES = [
  { id: 'ai-ml', name: 'AI & Machine Learning', icon: 'Brain', count: 3, color: 'from-pink-500 to-rose-600' },
  { id: 'cybersecurity', name: 'Cybersecurity', icon: 'Shield', count: 2, color: 'from-red-500 to-orange-600' },
  { id: 'web-dev', name: 'Web Development', icon: 'Code', count: 2, color: 'from-blue-500 to-indigo-600' },
  { id: 'data-science', name: 'Data Science', icon: 'BarChart3', count: 1, color: 'from-green-500 to-emerald-600' },
  { id: 'cloud', name: 'Cloud & Enterprise', icon: 'Cloud', count: 1, color: 'from-cyan-500 to-blue-600' },
];

export const COURSES = [
  {
    id: 'course-1',
    title: 'Generative AI',
    shortDescription: 'Master the fundamentals of Generative AI, LLMs, prompt engineering, and building AI-powered applications.',
    description: 'Dive deep into the world of Generative AI. Learn how large language models work, how to craft effective prompts, use APIs like OpenAI and Gemini, and build real-world GenAI applications from scratch.',
    category: 'ai-ml',
    level: 'Beginner',
    duration: '8 weeks',
    price: 32999,
    originalPrice: 59999,
    rating: 4.9,
    reviewCount: 615,
    students: 9800,
    instructor: { name: 'Dr. Priya Sharma', title: 'AI Research Lead', avatar: '' },
    featured: true,
    thumbnail: '',
    tags: ['GenAI', 'LLMs', 'Prompt Engineering', 'OpenAI'],
    curriculum: [
      { module: 'Introduction to Generative AI', lessons: 6, duration: '3h 30m' },
      { module: 'Large Language Models (LLMs)', lessons: 8, duration: '5h' },
      { module: 'Prompt Engineering Mastery', lessons: 7, duration: '4h 30m' },
      { module: 'Building with OpenAI & Gemini APIs', lessons: 9, duration: '6h' },
      { module: 'RAG & Vector Databases', lessons: 6, duration: '4h' },
      { module: 'Capstone: GenAI App', lessons: 4, duration: '8h' },
    ],
    projects: ['AI Content Generator', 'Document Q&A Bot', 'Image Generation App'],
    careerOutcomes: ['AI Engineer', 'GenAI Developer', 'Prompt Engineer'],
  },

  {
    id: 'course-2',
    title: 'Agentic AI',
    shortDescription: 'Build autonomous AI agents that can plan, reason, and execute complex multi-step tasks.',
    description: 'Learn to design and deploy agentic AI systems using frameworks like LangChain, AutoGen, and CrewAI. Understand tool use, memory, planning, and orchestration to build fully autonomous AI workflows.',
    category: 'ai-ml',
    level: 'Advanced',
    duration: '10 weeks',
    price: 41999,
    originalPrice: 72999,
    rating: 4.9,
    reviewCount: 644,
    students: 6500,
    instructor: { name: 'Arjun Mehta', title: 'AI Systems Architect', avatar: '' },
    featured: true,
    thumbnail: '',
    tags: ['LangChain', 'AutoGen', 'CrewAI', 'Agents'],
    curriculum: [
      { module: 'Foundations of Agentic Systems', lessons: 6, duration: '4h' },
      { module: 'LangChain & Tool Use', lessons: 8, duration: '5h 30m' },
      { module: 'Multi-Agent Frameworks (CrewAI, AutoGen)', lessons: 9, duration: '6h' },
      { module: 'Memory & Planning in Agents', lessons: 7, duration: '4h 30m' },
      { module: 'Agentic Workflows & Orchestration', lessons: 8, duration: '5h' },
      { module: 'Capstone: Autonomous Agent', lessons: 4, duration: '10h' },
    ],
    projects: ['Research Agent', 'Code Review Bot', 'Multi-Agent Task System'],
    careerOutcomes: ['AI Agent Developer', 'LLM Engineer', 'AI Automation Specialist'],
  },

  {
    id: 'course-3',
    title: 'AI & Machine Learning (AIML)',
    shortDescription: 'Complete AIML program from Python basics to deploying production ML models.',
    description: 'A comprehensive AI & Machine Learning course covering Python, data preprocessing, supervised and unsupervised learning, deep learning with TensorFlow, and end-to-end model deployment.',
    category: 'ai-ml',
    level: 'Intermediate',
    duration: '14 weeks',
    price: 46999,
    originalPrice: 84999,
    rating: 4.8,
    reviewCount: 672,
    students: 14200,
    instructor: { name: 'Dr. Neha Kapoor', title: 'ML Research Engineer', avatar: '' },
    featured: true,
    thumbnail: '',
    tags: ['Python', 'TensorFlow', 'Scikit-learn', 'Deep Learning'],
    curriculum: [
      { module: 'Python for AI/ML', lessons: 8, duration: '5h' },
      { module: 'Data Preprocessing & EDA', lessons: 7, duration: '4h 30m' },
      { module: 'Supervised Learning Algorithms', lessons: 10, duration: '7h' },
      { module: 'Unsupervised Learning & Clustering', lessons: 7, duration: '4h 30m' },
      { module: 'Deep Learning with TensorFlow', lessons: 10, duration: '8h' },
      { module: 'Model Deployment & MLOps', lessons: 6, duration: '4h' },
      { module: 'Capstone Project', lessons: 4, duration: '10h' },
    ],
    projects: ['Customer Churn Predictor', 'Image Classifier', 'NLP Sentiment Analyzer'],
    careerOutcomes: ['ML Engineer', 'Data Scientist', 'AI Developer'],
  },

  {
    id: 'course-4',
    title: 'Cyber Security (VAPT)',
    shortDescription: 'Master Vulnerability Assessment and Penetration Testing with real-world labs and tools.',
    description: 'An intensive cybersecurity program focused on VAPT - Vulnerability Assessment & Penetration Testing. Learn ethical hacking, network security, web app security, and use industry tools like Metasploit, Burp Suite, and Nmap.',
    category: 'cybersecurity',
    level: 'Advanced',
    duration: '12 weeks',
    price: 46999,
    originalPrice: 76999,
    rating: 4.8,
    reviewCount: 1056,
    students: 7200,
    instructor: { name: 'Vikram Singh', title: 'CISO & Security Consultant', avatar: '' },
    featured: true,
    thumbnail: '',
    tags: ['VAPT', 'Ethical Hacking', 'Burp Suite', 'Metasploit'],
    curriculum: [
      { module: 'Cybersecurity Fundamentals', lessons: 7, duration: '4h 30m' },
      { module: 'Network Scanning & Enumeration', lessons: 8, duration: '5h' },
      { module: 'Vulnerability Assessment', lessons: 9, duration: '6h' },
      { module: 'Exploitation with Metasploit', lessons: 8, duration: '6h' },
      { module: 'Web Application VAPT (Burp Suite)', lessons: 10, duration: '7h' },
      { module: 'Reporting & Remediation', lessons: 5, duration: '3h' },
    ],
    projects: ['Network Pen Test Report', 'Web App Security Audit', 'CTF Challenges'],
    careerOutcomes: ['Penetration Tester', 'Security Analyst', 'Ethical Hacker'],
  },

  {
    id: 'course-5',
    title: 'SOC (Security Operations Center)',
    shortDescription: 'Learn to monitor, detect, and respond to cybersecurity threats like a real SOC analyst.',
    description: 'Gain hands-on experience in Security Operations Center workflows. Learn SIEM tools (Splunk, IBM QRadar), threat intelligence, incident response, log analysis, and how to defend organizations against cyberattacks in real time.',
    category: 'cybersecurity',
    level: 'Intermediate',
    duration: '10 weeks',
    price: 37999,
    originalPrice: 62999,
    rating: 4.7,
    reviewCount: 383,
    students: 5100,
    instructor: { name: 'Ananya Rao', title: 'Senior SOC Analyst', avatar: '' },
    featured: false,
    thumbnail: '',
    tags: ['SIEM', 'Splunk', 'Incident Response', 'Threat Intel'],
    curriculum: [
      { module: 'SOC Fundamentals & Roles', lessons: 5, duration: '3h' },
      { module: 'SIEM Tools: Splunk & QRadar', lessons: 9, duration: '6h' },
      { module: 'Threat Intelligence & IOCs', lessons: 7, duration: '4h 30m' },
      { module: 'Log Analysis & Correlation', lessons: 8, duration: '5h 30m' },
      { module: 'Incident Response Playbooks', lessons: 7, duration: '4h 30m' },
      { module: 'Capstone: Simulated Attack', lessons: 4, duration: '6h' },
    ],
    projects: ['Incident Response Simulation', 'Splunk Dashboard', 'Threat Hunt Report'],
    careerOutcomes: ['SOC Analyst', 'Incident Responder', 'Threat Intelligence Analyst'],
  },

  {
    id: 'course-6',
    title: 'Full Stack Development',
    shortDescription: 'Build complete web applications from frontend to backend using modern technologies.',
    description: 'Master full stack web development with React, Node.js, Express, and MongoDB. Build and deploy production-ready applications, RESTful APIs, and learn best practices for modern web engineering.',
    category: 'web-dev',
    level: 'Beginner',
    duration: '16 weeks',
    price: 41999,
    originalPrice: 67999,
    rating: 4.8,
    reviewCount: 3100,
    students: 18500,
    instructor: { name: 'Rahul Desai', title: 'Senior Full Stack Engineer', avatar: '' },
    featured: true,
    thumbnail: '',
    tags: ['React', 'Node.js', 'MongoDB', 'REST API'],
    curriculum: [
      { module: 'HTML, CSS & Responsive Design', lessons: 8, duration: '5h' },
      { module: 'JavaScript & ES6+', lessons: 10, duration: '7h' },
      { module: 'React.js Frontend', lessons: 12, duration: '9h' },
      { module: 'Node.js & Express Backend', lessons: 10, duration: '7h' },
      { module: 'MongoDB & Database Design', lessons: 8, duration: '5h 30m' },
      { module: 'Deployment & DevOps Basics', lessons: 5, duration: '3h' },
      { module: 'Capstone Project', lessons: 5, duration: '12h' },
    ],
    projects: ['E-Commerce Platform', 'Blog CMS', 'Real-time Chat App'],
    careerOutcomes: ['Full Stack Developer', 'Frontend Engineer', 'Backend Developer'],
  },

  {
    id: 'course-7',
    title: 'Java Programming',
    shortDescription: 'From Java basics to advanced OOP, Spring Boot, and enterprise application development.',
    description: 'A comprehensive Java course covering core Java, object-oriented programming, data structures, collections, multithreading, JDBC, and Spring Boot for building enterprise-grade applications.',
    category: 'web-dev',
    level: 'Beginner',
    duration: '12 weeks',
    price: 33999,
    originalPrice: 54999,
    rating: 4.7,
    reviewCount: 421,
    students: 12000,
    instructor: { name: 'Karan Joshi', title: 'Java Architect & Tech Lead', avatar: '' },
    featured: false,
    thumbnail: '',
    tags: ['Java', 'Spring Boot', 'OOP', 'JDBC'],
    curriculum: [
      { module: 'Core Java Fundamentals', lessons: 10, duration: '6h' },
      { module: 'Object-Oriented Programming', lessons: 9, duration: '6h' },
      { module: 'Data Structures & Collections', lessons: 8, duration: '5h 30m' },
      { module: 'Multithreading & Concurrency', lessons: 7, duration: '4h 30m' },
      { module: 'JDBC & Database Integration', lessons: 6, duration: '4h' },
      { module: 'Spring Boot & REST APIs', lessons: 10, duration: '7h' },
      { module: 'Capstone: Enterprise App', lessons: 4, duration: '8h' },
    ],
    projects: ['Banking System', 'Employee Management App', 'REST API with Spring Boot'],
    careerOutcomes: ['Java Developer', 'Backend Engineer', 'Spring Boot Developer'],
  },

  {
    id: 'course-8',
    title: 'Python Programming',
    shortDescription: 'Learn Python from scratch - automation, scripting, web development, and data analysis.',
    description: 'Start your coding journey with Python. This course covers core Python programming, file handling, OOP, web scraping, automation with Selenium, Flask for web apps, and data analysis with Pandas.',
    category: 'data-science',
    level: 'Beginner',
    duration: '10 weeks',
    price: 28999,
    originalPrice: 49999,
    rating: 4.8,
    reviewCount: 365,
    students: 20000,
    instructor: { name: 'Sneha Iyer', title: 'Python Developer & Educator', avatar: '' },
    featured: true,
    thumbnail: '',
    tags: ['Python', 'Flask', 'Automation', 'Pandas'],
    curriculum: [
      { module: 'Python Basics & Syntax', lessons: 8, duration: '4h 30m' },
      { module: 'Functions, Modules & OOP', lessons: 9, duration: '6h' },
      { module: 'File Handling & Error Management', lessons: 6, duration: '3h 30m' },
      { module: 'Web Scraping with BeautifulSoup', lessons: 6, duration: '4h' },
      { module: 'Automation with Selenium', lessons: 7, duration: '4h 30m' },
      { module: 'Flask Web Development', lessons: 8, duration: '5h' },
      { module: 'Data Analysis with Pandas', lessons: 6, duration: '4h' },
    ],
    projects: ['Web Scraper Bot', 'Task Automation Script', 'Flask Blog App'],
    careerOutcomes: ['Python Developer', 'Automation Engineer', 'Data Analyst'],
  },

  {
    id: 'course-9',
    title: 'ServiceNow',
    shortDescription: 'Master the ServiceNow platform -* ITSM, workflow automation, and app development.',
    description: 'A comprehensive ServiceNow course covering IT Service Management (ITSM), the Now Platform, workflow automation, scripting with JavaScript, and building custom ServiceNow applications for enterprises.',
    category: 'cloud',
    level: 'Intermediate',
    duration: '10 weeks',
    price: 37999,
    originalPrice: 62999,
    rating: 4.7,
    reviewCount: 824,
    students: 4200,
    instructor: { name: 'Ravi Kumar', title: 'Certified ServiceNow Architect', avatar: '' },
    featured: false,
    thumbnail: '',
    tags: ['ServiceNow', 'ITSM', 'ITIL', 'No-Code'],
    curriculum: [
      { module: 'ServiceNow Platform Overview', lessons: 5, duration: '3h' },
      { module: 'IT Service Management (ITSM)', lessons: 8, duration: '5h' },
      { module: 'Workflow & Flow Designer', lessons: 7, duration: '4h 30m' },
      { module: 'Scripting in ServiceNow (JavaScript)', lessons: 9, duration: '6h' },
      { module: 'Custom App Development', lessons: 8, duration: '5h 30m' },
      { module: 'Integrations & REST APIs', lessons: 6, duration: '4h' },
    ],
    projects: ['IT Helpdesk Portal', 'Automated Incident Workflow', 'Custom CMDB App'],
    careerOutcomes: ['ServiceNow Developer', 'ITSM Consultant', 'Platform Administrator'],
  },
  
];

export const TESTIMONIALS = [
  { id: 1, name: 'Aisha Patel', role: 'Full-Stack Developer at Stripe', text: 'XceedEdge transformed my career. I went from zero coding knowledge to landing a $120K job in just 6 months. The project-based learning approach is unmatched.', rating: 5, course: 'Full-Stack Web Development' },
  { id: 2, name: 'Marcus Johnson', role: 'Data Scientist at Netflix', text: 'The Data Science course was incredibly comprehensive. The real-world projects gave me the confidence to ace my interviews. Best investment I\'ve ever made.', rating: 5, course: 'Data Science with Python' },
  { id: 3, name: 'Lisa Chang', role: 'Mobile Developer at Uber', text: 'I built 3 apps during the course and published them to the App Store. The instructor support and community are what make XceedEdge special.', rating: 5, course: 'React Native Development' },
  { id: 4, name: 'Raj Gupta', role: 'AI Engineer at DeepMind', text: 'The AI masterclass exceeded my expectations. Deep diving into neural networks with real research projects prepared me for an incredible career in AI.', rating: 5, course: 'AI & Deep Learning' },
  { id: 5, name: 'Sophie Martinez', role: 'UX Lead at Figma', text: 'The design curriculum is world-class. I went from knowing basic Canva to leading a design team. The portfolio project alone was worth the entire investment.', rating: 5, course: 'UI/UX Design Professional' },
];

export const BLOG_POSTS = [
  { id: 'blog-1', title: 'Why 2026 Is the Best Year to Start Coding', excerpt: 'With AI tools accelerating development, the demand for skilled developers has never been higher...', category: 'Career', readTime: '5 min', date: '2026-03-15', tags: ['Career', 'Coding', 'Tech'] },
  { id: 'blog-2', title: 'From Zero to $100K: A Student Success Story', excerpt: 'Meet Aisha, who went from retail to a six-figure tech salary in under a year...', category: 'Success Stories', readTime: '7 min', date: '2026-03-10', tags: ['Success', 'Inspiration'] },
  { id: 'blog-3', title: 'Top 10 Skills Employers Want in 2026', excerpt: 'We analyzed 10,000 job postings to find the most in-demand technical skills...', category: 'Industry', readTime: '6 min', date: '2026-03-05', tags: ['Skills', 'Jobs', 'Industry'] },
  { id: 'blog-4', title: 'The Complete Guide to Learning Data Science', excerpt: 'A roadmap for aspiring data scientists, from statistics to machine learning...', category: 'Learning', readTime: '8 min', date: '2026-02-28', tags: ['Data Science', 'Guide'] },
  { id: 'blog-5', title: 'How AI Is Changing Education Forever', excerpt: 'Personalized learning, AI tutors, and the future of online education...', category: 'Technology', readTime: '5 min', date: '2026-02-20', tags: ['AI', 'Education', 'Future'] },
];

export const QUIZ_DATA = {
  'course-1': [
    { id: 1, question: 'What does LLM stand for in AI?', options: ['Large Language Model', 'Low Level Machine', 'Layered Learning Module', 'Large Logic Model'], correct: 0 },
    { id: 2, question: 'Which company developed ChatGPT?', options: ['Google', 'Meta', 'OpenAI', 'Anthropic'], correct: 2 },
    { id: 3, question: 'What is prompt engineering?', options: ['Building software prompts', 'Crafting inputs to guide AI outputs', 'Engineering AI hardware', 'Training neural networks'], correct: 1 },
    { id: 4, question: 'What does RAG stand for?', options: ['Rapid AI Generation', 'Retrieval-Augmented Generation', 'Random Attention Graph', 'Recursive AI Grouping'], correct: 1 },
    { id: 5, question: 'Which of these is a generative AI model?', options: ['Random Forest', 'SVM', 'GPT-4', 'K-Means'], correct: 2 },
  ],
  'course-3': [
    { id: 1, question: 'What is supervised learning?', options: ['Learning without labels', 'Learning with labeled data', 'Reinforcement-based learning', 'Self-supervised learning'], correct: 1 },
    { id: 2, question: 'Which Python library is used for ML?', options: ['Flask', 'Django', 'Scikit-learn', 'NumPy'], correct: 2 },
    { id: 3, question: 'What is overfitting?', options: ['Model performs well on test data', 'Model performs well only on training data', 'Model has too few parameters', 'Model is too simple'], correct: 1 },
    { id: 4, question: 'What activation function is commonly used in output layers for classification?', options: ['ReLU', 'Sigmoid', 'Tanh', 'Softmax'], correct: 3 },
    { id: 5, question: 'What does CNN stand for?', options: ['Contextual Neural Network', 'Convolutional Neural Network', 'Combined Node Network', 'Cyclic Neuron Network'], correct: 1 },
  ],
  'course-6': [
    { id: 1, question: 'What does HTML stand for?', options: ['Hyper Text Markup Language', 'High Tech Modern Language', 'Hyper Transfer Markup Language', 'Home Tool Markup Language'], correct: 0 },
    { id: 2, question: 'Which React hook is used for side effects?', options: ['useState', 'useEffect', 'useContext', 'useReducer'], correct: 1 },
    { id: 3, question: 'What does REST stand for?', options: ['Remote Execution State Transfer', 'Representational State Transfer', 'Rapid Event Service Transfer', 'Relational Entity State Transfer'], correct: 1 },
    { id: 4, question: 'Which database is document-oriented?', options: ['MySQL', 'PostgreSQL', 'MongoDB', 'SQLite'], correct: 2 },
    { id: 5, question: 'What is Node.js?', options: ['A browser plugin', 'A JavaScript runtime for servers', 'A CSS framework', 'A database'], correct: 1 },
  ],
};

export const ROADMAP_STEPS = [
  { step: 1, title: 'Choose Your Path', description: 'Explore our courses and pick the perfect learning track for your career goals.' },
  { step: 2, title: 'Learn by Building', description: 'Work on real-world projects with expert-guided curriculum and hands-on exercises.' },
  { step: 3, title: 'Get Certified', description: 'Complete assessments and earn industry-recognized certificates to showcase your skills.' },
  { step: 4, title: 'Land Your Dream Job', description: 'Leverage our placement support, resume reviews, and interview prep to get hired.' },
];

export const STATS = [
  { label: 'Students Enrolled', value: 50000, suffix: '+' },
  { label: 'Placement Rate', value: 94, suffix: '%' },
  { label: 'Expert Instructors', value: 120, suffix: '+' },
  { label: 'Industry Partners', value: 300, suffix: '+' },
];

// localStorage helpers
export function getUser() {
  const user = localStorage.getItem('xceedge_user');
  if (user) {
    try {
     return user ? JSON.parse(user) : null;
    } catch (e) {
      console.error('Error parsing user data from localStorage', e);
      return null;
    }
  }
  return null;
  
}

export function setUser(user) {
  localStorage.setItem('xceedge_user', JSON.stringify(user));
}

export function clearUser() {
  localStorage.removeItem('xceedge_user');
}

export function getEnrolledCourses() {
  const courses = localStorage.getItem('xceedge_enrolled');
  return courses ? JSON.parse(courses) : [];
}

export function enrollInCourse(courseId) {
  const enrolled = getEnrolledCourses();
  if (!enrolled.find(e => e.courseId === courseId)) {
    enrolled.push({ courseId, enrolledDate: new Date().toISOString(), progress: 0, completedLessons: [] });
    localStorage.setItem('xceedge_enrolled', JSON.stringify(enrolled));
  }
  return enrolled;
}

export function updateCourseProgress(courseId, lessonIndex) {
  const enrolled = getEnrolledCourses();
  const course = enrolled.find(e => e.courseId === courseId);
  if (course) {
    if (!course.completedLessons.includes(lessonIndex)) {
      course.completedLessons.push(lessonIndex);
    }
    const totalLessons = COURSES.find(c => c.id === courseId)?.curriculum.reduce((sum, m) => sum + m.lessons, 0) || 1;
    course.progress = Math.round((course.completedLessons.length / totalLessons) * 100);
    localStorage.setItem('xceedge_enrolled', JSON.stringify(enrolled));
  }
  return enrolled;
}

export function getWishlist() {
  const wishlist = localStorage.getItem('xceedge_wishlist');
  return wishlist ? JSON.parse(wishlist) : [];
}

export function toggleWishlist(courseId) {
  let wishlist = getWishlist();
  if (wishlist.includes(courseId)) {
    wishlist = wishlist.filter(id => id !== courseId);
  } else {
    wishlist.push(courseId);
  }
  localStorage.setItem('xceedge_wishlist', JSON.stringify(wishlist));
  return wishlist;
}

export function getNotifications() {
  return [
    { id: 1, type: 'course', title: 'New lesson available', message: 'React Mastery Module 3 is now live!', time: '2 hours ago', read: false },
    { id: 2, type: 'assignment', title: 'Assignment due soon', message: 'Submit your capstone project by Friday.', time: '5 hours ago', read: false },
    { id: 3, type: 'announcement', title: 'Platform update', message: 'New AI features added to the learning platform.', time: '1 day ago', read: true },
    { id: 4, type: 'course', title: 'Certificate ready', message: 'Your Web Development certificate is available for download.', time: '2 days ago', read: true },
  ];
}

// Demo admin data
export const ADMIN_USERS = [
  { id: 1, name: 'Aisha Patel', email: 'aisha@email.com', role: 'student', status: 'active', enrolled: 3, joined: '2025-12-01' },
  { id: 2, name: 'Marcus Johnson', email: 'marcus@email.com', role: 'student', status: 'active', enrolled: 2, joined: '2025-11-15' },
  { id: 3, name: 'Lisa Chang', email: 'lisa@email.com', role: 'student', status: 'active', enrolled: 1, joined: '2026-01-10' },
  { id: 4, name: 'Raj Gupta', email: 'raj@email.com', role: 'instructor', status: 'active', enrolled: 0, joined: '2025-10-01' },
  { id: 5, name: 'Sophie Martinez', email: 'sophie@email.com', role: 'student', status: 'blocked', enrolled: 2, joined: '2025-09-20' },
];

export const ADMIN_TRANSACTIONS = [
  { id: 'TXN001', user: 'Aisha Patel', course: 'Full-Stack Web Development', amount: 499, date: '2026-03-20', status: 'completed' },
  { id: 'TXN002', user: 'Marcus Johnson', course: 'Data Science with Python', amount: 449, date: '2026-03-18', status: 'completed' },
  { id: 'TXN003', user: 'Lisa Chang', course: 'React Native Development', amount: 399, date: '2026-03-15', status: 'refunded' },
  { id: 'TXN004', user: 'Unknown User', course: 'AI & Deep Learning', amount: 599, date: '2026-03-12', status: 'completed' },
  { id: 'TXN005', user: 'Sophie Martinez', course: 'UI/UX Design', amount: 349, date: '2026-03-10', status: 'pending' },
];